import { Box, Input } from '@chakra-ui/react';
import React, { useCallback, useEffect, useRef } from 'react';
import { DataEditorProps } from 'react-spreadsheet';

export const CustomDataEditor = ({ onChange, cell }: DataEditorProps) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange({ ...cell, value: event.target.value });
    },
    [onChange, cell],
  );

  useEffect(() => {
    const currentRef = inputRef.current;
    if (currentRef) {
      // This helps drive cursor selection when initially clicking into cell
      currentRef.selectionStart = 0;
      currentRef.selectionEnd = currentRef.value.length;
    }
  }, [inputRef]);

  return (
    <Box className="Spreadsheet__data-editor">
      <Input
        ref={inputRef}
        type="text"
        onChange={handleChange}
        value={cell?.value ?? ''}
        autoFocus
      />
    </Box>
  );
};
